import { jsx as _jsx } from "react/jsx-runtime";
import CloseIcon from "@mui/icons-material/Close";
import { SnackbarProvider, useSnackbar } from "notistack";
import { CloseToastFab } from "../Shared/components/Buttons/ExtraSmallFAB";
const SnackBarCloseButton = ({ snackbarKey }) => {
    const { closeSnackbar } = useSnackbar();
    return _jsx(CloseToastFab, { icon: CloseIcon, "aria-label": "close", onClick: () => closeSnackbar(snackbarKey) });
};
/**
 * ToastContainer - Provider for the toast component.
 * @param {*} children
 */
export const ToastContainer = ({ children }) => {
    return (_jsx(SnackbarProvider, Object.assign({ action: (snackbarKey) => _jsx(SnackBarCloseButton, { snackbarKey: snackbarKey }), maxSnack: 2, anchorOrigin: {
            vertical: "top",
            horizontal: "center",
        }, autoHideDuration: 5000 }, { children: children })));
};
/**
 * useToast()
 * This is a custom hook that handles toast .notifications
 * It uses notistacks useSnackbar hook which has its own context.
 */
const useToast = () => {
    const { enqueueSnackbar } = useSnackbar();
    const push = (message, variant) => {
        enqueueSnackbar(message, variant);
    };
    return { push };
};
export default useToast;
